import React, { useState } from 'react';
import styles from './NavBar.module.css';
import cv from '../../common/assets/ANDRES_FRANK_RESUME.pdf';
import axios from 'axios';

const NavBar = () => {
    const [mode, setMode] = useState(true);

    function handleClick(e) {
        setMode(!mode)
        document.documentElement.classList.toggle('light');        
    }

    function handleLogoClick(e) {
        window.location.href = '/#home';
    }

    async function handleDownloadClick(e) {
        try {
            axios.post('/downloaded-cv');
        } catch(e) {
            console.log(e);
        }
    }

    return (
        <nav className={styles.nav}>
            <div onClick={e => handleLogoClick(e)} className={styles.logo}>
                <span className={styles.logoSpan}>AF</span>
            </div>
            <ul className={styles.list}>
                <a className={styles.anchor} href="/#projects">
                    <li className={styles.listItem}>PROJECTS</li>
                </a>
                <a className={styles.anchor} href="/#experience">
                    <li className={styles.listItem}>EXPERIENCE</li>
                </a>
                <a className={styles.anchor} href="/#about">
                    <li className={styles.listItem}>ABOUT</li>
                </a>
                <a className={styles.anchor} href="/#contact">
                    <li className={styles.listItem}>CONTACT</li>
                </a>
                <a 
                    onClick={e => handleDownloadClick(e)}
                    href={cv}
                    download="ANDRES_FRANK_RESUME"
                    className={styles.anchor}
                >
                    <li className={styles.listItem}>CV</li>
                </a>
                <div onClick={e => handleClick(e)} className={styles.modeContainer}>
                    <div className={mode ? styles.modeSwitchLight : styles.modeSwitchDark}></div>
                </div>
            </ul>
        </nav>
    )
}

export default NavBar;
